import type { LocalThemeSearchRequest } from 'pages/WebsiteDesignsPLPSSR/api/themes';
import type { RootState } from 'reducers/index';
import type { AppDispatch } from 'reducers/useAppDispatch';

import { websiteV2ThemeSearch } from '../api/themes';
import { requestThemes, receiveThemeSearch } from './websitePlpActions';

// Split out of "websitePlpActions" to avoid bundling ApiService with our reducers.

export const fetchThemesWebsiteV2 = (searchRequest: LocalThemeSearchRequest) => (
  dispatch: AppDispatch,
  getState: () => RootState
): Promise<void> => {
  const isFetching = getState().websitePlp.busy;
  if (!isFetching) {
    dispatch(requestThemes());
    return websiteV2ThemeSearch(searchRequest).then(themeSearchView => {
      dispatch(receiveThemeSearch(themeSearchView));
    });
  }
  return Promise.resolve();
};
